import Discord_logo from "../../assets/common/discord-logo.svg";
import Twitter_logo from "../../assets/common/twitter-logo.svg";
import Instagram_logo from "../../assets/common/instagram-logo.svg";
import YT_Logo from "../../assets/common/yt-logo.svg";

// Social profiles + their (white) logos, shared by the footer and the phone hero
export const SOCIAL_LINKS = [
  { label: "YouTube", href: "https://www.youtube.com/@HitwicketGame", icon: YT_Logo },
  { label: "Instagram", href: "https://www.instagram.com/hitwicketsuperstars/", icon: Instagram_logo },
  { label: "Twitter", href: "https://twitter.com/HitwicketGame", icon: Twitter_logo },
  { label: "Discord", href: "https://discord.gg/aHEutBHp8d", icon: Discord_logo },
];
